module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-light-gray-8af8b9353951e2eed57cc23e560d4326.png";